"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _ErrorResponse = _interopRequireDefault(require("../model/ErrorResponse"));
var _GetQuestionnaireParams = _interopRequireDefault(require("../model/GetQuestionnaireParams"));
var _GetQuestionnairesObject = _interopRequireDefault(require("../model/GetQuestionnairesObject"));
var _Language = _interopRequireDefault(require("../model/Language"));
var _QuestionnaireGetUserQuestionnairePost200Response = _interopRequireDefault(require("../model/QuestionnaireGetUserQuestionnairePost200Response"));
var _QuestionnaireSubmitUserQuestionnairePost200Response = _interopRequireDefault(require("../model/QuestionnaireSubmitUserQuestionnairePost200Response"));
var _SubmitQuestionnaireParams = _interopRequireDefault(require("../model/SubmitQuestionnaireParams"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Manage My Pain API
 * This document provide full documentation for [ManagingLife](http://managinglife.com) API # Introduction Each API call only supports POST calls, and all parameters goes to body of POST request<br> Format of each API endpoint is `https://SERVER.managinglife.com/api/vVERSION/SERVICE/METHOD`   - **SERVER** could be one of: *dev*, *preprod*, *sync*.   - **VERSION** could be one of: *1*, *3*, *4*.   - **SERVICE** e.g. *core*, *sync*, *alerts*.   - **METHOD** e.g. *generate-report*, *login-user*, *update-records*.  Any parameter that is not marked as required can be null or omitted. # Client libraries We also provide several client libraries which were auto-generated using swagger-codegen.   - [JavaScript](/codegen/javascript)   - [Java](/codegen/java)   - [PHP](/codegen/php)   - [Objective C](/codegen/objc) # Authentication <!-- ReDoc-Inject: <security-definitions> --> 
 *
 * The version of the OpenAPI document: 4.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
* UserQuestionnaires service.
* @module api/UserQuestionnairesApi
* @version 4.0.0
*/
var UserQuestionnairesApi = exports["default"] = /*#__PURE__*/function () {
  /**
  * Constructs a new UserQuestionnairesApi. 
  * @alias module:api/UserQuestionnairesApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function UserQuestionnairesApi(apiClient) {
    _classCallCheck(this, UserQuestionnairesApi);
    this.apiClient = apiClient || _ApiClient["default"].instance;
  }

  /**
   * get-questionnaire
   * Get questionnaire by ID if available for user
   * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
   * @param {module:model/GetQuestionnaireParams} params 
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/QuestionnaireGetUserQuestionnairePost200Response} and HTTP response
   */
  return _createClass(UserQuestionnairesApi, [{
    key: "questionnaireGetQuestionnairePostWithHttpInfo",
    value: function questionnaireGetQuestionnairePostWithHttpInfo(Accept_Language, params) {
      var postBody = params;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling questionnaireGetQuestionnairePost");
      }
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling questionnaireGetQuestionnairePost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = ['token'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _QuestionnaireGetUserQuestionnairePost200Response["default"];
      return this.apiClient.callApi('/questionnaire/get-questionnaire', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * get-questionnaire
     * Get questionnaire by ID if available for user
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/GetQuestionnaireParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/QuestionnaireGetUserQuestionnairePost200Response}
     */
  }, {
    key: "questionnaireGetQuestionnairePost",
    value: function questionnaireGetQuestionnairePost(Accept_Language, params) {
      return this.questionnaireGetQuestionnairePostWithHttpInfo(Accept_Language, params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * get-questionnaires
     * Get all questionnaires available for user
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/GetQuestionnairesObject>} and HTTP response
     */
  }, {
    key: "questionnaireGetQuestionnairesPostWithHttpInfo",
    value: function questionnaireGetQuestionnairesPostWithHttpInfo() {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['token'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [_GetQuestionnairesObject["default"]];
      return this.apiClient.callApi('/questionnaire/get-questionnaires', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * get-questionnaires
     * Get all questionnaires available for user
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/GetQuestionnairesObject>}
     */
  }, {
    key: "questionnaireGetQuestionnairesPost",
    value: function questionnaireGetQuestionnairesPost() {
      return this.questionnaireGetQuestionnairesPostWithHttpInfo().then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * submit-questionnaire
     * Submit questionnaire by user
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/SubmitQuestionnaireParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/QuestionnaireSubmitUserQuestionnairePost200Response} and HTTP response
     */
  }, {
    key: "questionnaireSubmitQuestionnairePostWithHttpInfo",
    value: function questionnaireSubmitQuestionnairePostWithHttpInfo(Accept_Language, params) {
      var postBody = params;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling questionnaireSubmitQuestionnairePost");
      }
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling questionnaireSubmitQuestionnairePost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = ['token'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _QuestionnaireSubmitUserQuestionnairePost200Response["default"];
      return this.apiClient.callApi('/questionnaire/submit-questionnaire', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * submit-questionnaire
     * Submit questionnaire by user
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/SubmitQuestionnaireParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/QuestionnaireSubmitUserQuestionnairePost200Response}
     */
  }, {
    key: "questionnaireSubmitQuestionnairePost",
    value: function questionnaireSubmitQuestionnairePost(Accept_Language, params) {
      return this.questionnaireSubmitQuestionnairePostWithHttpInfo(Accept_Language, params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);
}();